// Helpers for the live net-scan log viewer. Kept framework-free so they can be
// unit-tested without mounting the component.

/** WS URL for the admin log stream, mirroring the terminal component's scheme
 *  choice (wss on https, ws on http). */
export function getLogWsUrl(actionId: string): string {
  const proto = window.location.protocol === "https:" ? "wss:" : "ws:";
  return `${proto}//${window.location.host}/api/v1/view/nmap/log/ws/${actionId}`;
}

/** Append a streamed chunk to the accumulated log, keeping only the last
 *  `maxLines` lines so a long scan cannot grow the DOM without bound. */
export function appendLogLine(
  current: string,
  chunk: string,
  maxLines = 5000,
): string {
  const next = current + chunk;
  // Trailing "" from a terminating newline is not a line: drop it before
  // counting so the cap keeps maxLines real lines.
  const lines = next.split("\n");
  const trailingEmpty = lines[lines.length - 1] === "";
  if (trailingEmpty) lines.pop();
  if (lines.length <= maxLines) return next;
  const kept = lines.slice(lines.length - maxLines);
  return kept.join("\n") + (trailingEmpty ? "\n" : "");
}
